import React, { useEffect } from 'react';
import { Alert } from '@material-tailwind/react';

const NotificationProvider = ({ children, snackbar, onClose }) => {
    useEffect(() => {
        if (snackbar.open) {
            const timer = setTimeout(() => {
                onClose();
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, [snackbar.open, onClose]);

    return (
        <>
            {children}
            {snackbar.open && (
                <div className="fixed bottom-4 right-4 z-50">
                    <Alert
                        color={snackbar.severity === 'error' ? 'red' :
                            snackbar.severity === 'warning' ? 'amber' :
                                snackbar.severity === 'success' ? 'green' : 'blue'}
                        dismissible={{
                            onClose: onClose
                        }}
                    >
                        {snackbar.message}
                    </Alert>
                </div>
            )}
        </>
    );
};

export default NotificationProvider;
